define('LNRS/Components/Social/SocialGoogleplus',["jquery", "eventManager"], function ($, eventManager) {
    function SocialGoogleplus(scope) {
        eventManager.subscribe("SiteSharingDataLoaded", function (socailSharingData) {
            console.log(socailSharingData);
        }.bind(this));
    }

    return function init(args) {
        return new SocialGoogleplus(args.scope);
    };
});
